import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export interface DayTime {
    day: string;
    start: string;
    end: string;
}

@Component({
    selector: 'app-day-time-selector',
    templateUrl: './day-time-selector.component.html',
    styleUrls: ['./day-time-selector.component.scss']
})
export class DayTimeSelectorComponent implements OnChanges {
    @Input() value?: string | DayTime[] = [];
    @Output() valueChange = new EventEmitter<string>();

    dayTimeForm: FormGroup;
    showForm = false;
    badges: DayTime[] = [];
    days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

    constructor(private fb: FormBuilder) {
        this.dayTimeForm = this.fb.group({
            day: [null, Validators.required],
            start: [null, Validators.required],
            end: [null, Validators.required],
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['value']) {
            if (Array.isArray(this.value)) {
                this.badges = [...this.value];
            } else if (typeof this.value === 'string') {
                this.badges = this.parseStringToArray(this.value);
            }
        }
    }

    toggleForm() {
        this.showForm = !this.showForm;
        if (this.showForm) this.dayTimeForm.reset();
    }

    add() {
        if (this.dayTimeForm.valid) {
            const badge: DayTime = { ...this.dayTimeForm.value };
            this.badges.push(badge);
            this.dayTimeForm.reset();
            this.showForm = false;
            this.valueChange.emit(this.badges.map(b => `${b.day}, ${this.formatTime(b.start)}-${this.formatTime(b.end)}`).join(' | '));
        }
    }

    remove(index: number) {
        this.badges.splice(index, 1);
        this.valueChange.emit(this.badges.map(b => `${b.day}, ${this.formatTime(b.start)}-${this.formatTime(b.end)}`).join(' | '));
    }


    parseStringToArray(str: string): DayTime[] {
        if (!str) return [];
        return str.split('|').map(part => {
            const [dayPart, timePart] = part.trim().split(',');
            const [start, end] = timePart.trim().split('-');
            return { day: dayPart.trim(), start: this.to24Hour(start), end: this.to24Hour(end) };
        });
    }

    to24Hour(time: string): string {
        const match = time.match(/(\d+)(?::(\d+))?\s*(AM|PM)/i);
        if (!match) return time;
        let [, hour, minute, ampm] = match;
        let h = parseInt(hour, 10);
        if (ampm.toUpperCase() === 'PM' && h !== 12) h += 12;
        if (ampm.toUpperCase() === 'AM' && h === 12) h = 0;
        return `${h.toString().padStart(2, '0')}:${(minute || '00').padStart(2, '0')}`;
    }

    formatTime(time: string): string {
        if (!time) return '';
        const [hour, minute] = time.split(':').map(Number);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        const hour12 = hour % 12 || 12;
        return `${hour12}:${minute.toString().padStart(2, '0')}${ampm}`;
    }
}
